module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 023.0e910969.jpg";